import React from 'react';

import OpsTeamHuddleContainer from '@totem/components/ticketing/opsTeamHuddle/OpsTeamHuddleContainer';
import OpsTeamHuddleLayout from '@totem/components/ticketing/opsTeamHuddle/OpsTeamHuddleLayout';

const OpsTeamHuddlePage = () => (
  <OpsTeamHuddleContainer>
    <OpsTeamHuddleLayout />
  </OpsTeamHuddleContainer>
);

export default OpsTeamHuddlePage;
